import React from 'react';
//generics
import { IHeaderIndicator } from './interface';
import { IsNullOrEmpty } from 'utils/StringNullOrEmpty';
//components
import { Visibility } from 'components/Visibility';
//assets
import { HeaderIndicatorComponent, HeaderIndicatorContent } from './styles';

const HeaderIndicator: React.FC<IHeaderIndicator> = (props) => {
  const {
    indicatorColor,
    information,
    title,
  } = props;

  return (
    <HeaderIndicatorComponent indicatorColor={indicatorColor}>
      <HeaderIndicatorContent indicatorColor={indicatorColor} >
        <h1>{title}</h1>
        <Visibility visible={!IsNullOrEmpty(information)}>
          <p>{information}</p>
        </Visibility>
      </HeaderIndicatorContent>
    </HeaderIndicatorComponent>
  );
};

export default HeaderIndicator;